module.exports = __webpack_public_path__ + "media/images/icons/i-ad5ecc8c0ae5e6e3cc20a696f1d64ed0.svg";